
import AppSvc from "../../../services/app-svc";
import { setRefreshTokenCookie } from '@fixit/utils/src/functionFn';

export default {
  name: "the-selection",
  components: {},
  props: {
    apiUrl: {
      type: String,
      required: true,
    },
    isMounted: {
      type: Boolean,
      required: true,
    },
    oauthUrl: {
      type: String,
      required: true,
    },
    layout: {
      type: String,
      required: false,
      default: 'chain'
    },
    isProfile: {
      type: Boolean,
      required: false,
      default: false
    },
    useFixitOauthLogin: {
      type: Boolean,
      required: false,
      default: false
    },
    simplifiedLogin: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data() {
    return {
      vippsIcon: require("../../../assets/img/vipps-logo-orange.png"),
      googleIcon: require("../../../assets/img/google-logo-login.svg"),
      appleIcon: require("../../../assets/img/apple-logo-black.svg"),
      fixitIcon: require('../../../assets/img/fixit-logo-white.png'),
      code: '',
      oauthEventListenerHandler: null
    };
  },
  computed: {
    chainName() {
      return this.$store.getters['cmsConfigHomepage/getChainName'] || 'Salongene'
    }
  },
  methods: {
    startRedirectTimer() {
      setTimeout(() => {
        this.oauthLogin('portal')
      }, 2000)
    },
    changeView(view) {
      // Track selected method
      if (this.layout === 'portal' && !this.isProfile) {
        if (view === 'login') {
          window.CONFIG.google.sendEventButtonClick('login-with-user', 'Logg inn med din bruker','' )
        }
      } 
      this.$emit("changeView", view);
    },
    close() {
      this.$emit("close");
    },
    portalUrl() {
      return this.layout == 'portal' ? process.env.VUE_APP_FIXIT_NO_URL : this.$config.PORTAL_URL
    },
    oauthLogin(type) {
      // Track selected method
      if (this.layout === 'portal' && !this.isProfile) {
          window.CONFIG.google.sendEventButtonClick('login-with-' + type, 'Logg inn med ' + type, '')
      } 

      let url = "";
      let redirectUrl = window.location.href;
      if (type === 'vipps') {
        if (this.useFixitOauthLogin) {
          url = window.location.href
          if (url.slice(-1) != '/') {
            url += '/'
          }
          url += `oauth-vipps-login?redirectUri=${encodeURI(redirectUrl)}`
        } else {
          url = this.oauthUrl + `?oauthTarget=vipps&redirectUri=${encodeURI(redirectUrl)}`
        }
        if (this.$route.query.siteId && this.$route.query.customerId) {
          url += `&siteId=${this.$route.query.siteId}&customerId=${this.$route.query.customerId}`
        }
      } else if (type === 'google') {
        if (this.useFixitOauthLogin) {
          url = window.location.href
          if (url.slice(-1) != '/') {
            url += '/'
          }
          url += `oauth-google-login?redirectUri=${encodeURI(redirectUrl)}`
        } else {
          url = this.oauthUrl + `?oauthTarget=google&redirectUri=${encodeURI(redirectUrl)}`
        }
        if (this.$route.query.siteId && this.$route.query.customerId) {
          url += `&siteId=${this.$route.query.siteId}&customerId=${this.$route.query.customerId}`
        }
      } else if (type === 'apple') {
        if (this.useFixitOauthLogin) {
          url = window.location.href
          if (url.slice(-1) != '/') {
            url += '/'
          }
          url += `oauth-apple-login?redirectUri=${encodeURI(redirectUrl)}`
        } else {
          url = this.oauthUrl + `?oauthTarget=apple&redirectUri=${encodeURI(redirectUrl)}`
        }
        if (this.$route.query.siteId && this.$route.query.customerId) {
          url += `&siteId=${this.$route.query.siteId}&customerId=${this.$route.query.customerId}`
        }
      }
      else if (type === 'fixit') {
        url = window.location.href
        if (url.slice(-1) != '/') {
          url += '/'
        }
        url += 'oauth-login'
      }
      else if (type === 'portal') {
         let returnUrl = window.location.href;
          url = window.location.origin;
        if (url.slice(-1) != '/') {
          url += '/'
        }
         url += 'oauth-fixit-login' + '?returnUrl=' + encodeURI(returnUrl)
      }
      window.location.href = url
    },
        async oauthEventListener(event) {
      if (event.origin != this.oauthUrl) {
        return
      }

      if (event.data.oauthTarget === 'fixit') {
        let service = await AppSvc(this.useAxios ? this.$axios : null);
        let responseUrl = new URL(event.data.tokenUrl)
        if (responseUrl.searchParams.get('state') !== this.$route.query.state)
          return this.$emit('notify', {
            visible: true,
            duration: 3000,
            state: 'error',
            message: 'Påloggingen er utløpt, prøv igjen',
          })
        let oauthResponse = await service.OAuthLogin(event.data.tokenUrl)
        setRefreshTokenCookie(oauthResponse.data.refreshToken, oauthResponse.data.expiresIn, 'refreshTokenOauth')
        this.$axios.defaults.headers.common["Authorization"] = `Bearer ${oauthResponse.data.accessToken}`
        let user = await service.getCurrentUser(this.apiUrl)
        this.$emit('setUser', user)
      }
    }
  },
  async created() {
    this.oauthEventListenerHandler = this.oauthEventListener.bind(this);
    window.addEventListener("message", this.oauthEventListenerHandler, false);
    if (localStorage.getItem('origin') === 'fixitOAuth') {
      this.changeView('login')
    }
  },
  beforeDestroy() {
    window.removeEventListener("message", this.oauthEventListenerHandler, false);
  }
};
